import { render, staticRenderFns } from "./EditRecruitingProfileBio.vue?vue&type=template&id=c33964f2&scoped=true&"
import script from "./EditRecruitingProfileBio.vue?vue&type=script&lang=ts&"
export * from "./EditRecruitingProfileBio.vue?vue&type=script&lang=ts&"
import style0 from "./EditRecruitingProfileBio.vue?vue&type=style&index=0&id=c33964f2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33964f2",
  null
  
)

export default component.exports